import React, { useState } from "react";
import axios from 'axios';
import emailjs from 'emailjs-com';
import {
    Stepper,
    Step,
    StepLabel,
    StepContent,
    Button,
    TextField,
    FormControl,
    MenuItem,
    Select,
    InputLabel,
    Typography,
    Checkbox,
    FormControlLabel,
    Grid,
    Snackbar
} from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import '../Components/sgpform2025.css';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
    rootouter: {
        backgroundColor: '#fff',
        backgroundSize: 'contain',
        backgroundRepeat: 'repeat',
        backgroundPosition: 'bottom',
    },
    divider: {
        backgroundColor: '#002147',
    },
    root: {
        margin: '24px 0px',
        position: 'relative',
        backgroundColor: '#fff',
        maxWidth: '900px',
        top: '-17.5vw',
        padding: '60px 20px 60px 20px',
        boxShadow: '0 0 10px 0 rgba(0,0,0,0.2)',	
        borderRadius: '25px',
        '& p': {
            fontSize: '0.9rem',
        },
        '@media (min-width: 768px)': {
          marginLeft: 'auto',
          marginRight: 'auto',
          padding: '60px 80px 60px 80px',
          borderRadius: '5px'
        }
    },
    redText: {
        color: '#b91c1c',
    },
    stepper: {
        background: 'transparent',
        padding: 0,
        marginBottom: theme.spacing(3),
    },
    stepperVertical: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        '& .MuiStepConnector-root': {
            marginLeft: 12,
        }
    },
    stepContent: {
        marginTop: theme.spacing(2),
    },
    sectionTitle: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        fontWeight: 700,
        color: '#1f2937',
    },
    card: {
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(2),
    },
    field: {
        width: '100%',
        paddingRight: '10px'
    },
    addButton: {
        marginTop: theme.spacing(1),
    },
    actionRow: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginTop: theme.spacing(3),
    },
    primaryButton: {
        backgroundColor: '#0b488fff',
        borderColor: '#0b488fff',
        color: '#fff',
        marginLeft: theme.spacing(1),
        '&:hover': {
            backgroundColor: '#082f5bff',
            borderColor: '#082f5bff',
            color: '#fff',
        },
    },
    secondaryButton: {
        color: theme.palette.error.main,
    },
    errorText: {
        color: theme.palette.error.main,
        marginTop: theme.spacing(1),
        fontSize: '0.95rem',
    },
    rulesBox: {
        border: '1px solid rgba(15,23,42,0.06)',
        fontSize: '0.9rem',
        borderRadius: 10,
        padding: theme.spacing(2),
        background: '#fafafa',
        maxHeight: 360,
        overflowY: 'auto',
        marginBottom: theme.spacing(2),
    },
    formField: {
        marginBottom: theme.spacing(3),
    },
    uploadedImg: {
        height: '100px',
        paddingLeft: '20px'
    },
}));

export default function Masttshaala2026() {
    const classes = useStyles();

    const steps = [
        "Rules & Regulations",
        "Student's Personal Details",
        "Parents / Guardian Details",
        "Other Details",
        "Preview & Submit",
    ];

    const [activeStep, setActiveStep] = useState(0);
    const [errors, setErrors] = useState({});
    const [consentChecked, setConsentChecked] = useState(false);

    // Student's Personal Details
    const [studentFullName, setStudentFullName] = useState("");
    const [studentAge, setStudentAge] = useState("");
    const [studentGender, setStudentGender] = useState("");
    const [studentDOB, setStudentDOB] = useState("");
    const [city, setCity] = useState("");
    const [fullAddress, setFullAddress] = useState("");

    // Parents / Guardian Details
    const [parentMobileNo, setParentMobileNo] = useState("");
    const [parentEmailId, setParentEmailId] = useState("");
    const [parentPanNo, setParentPanNo] = useState("");

    // Other Details
    const [passportPhoto, setPassportPhoto] = useState(null);
    const [aadharCard, setAadharCard] = useState(null);
    const [roomPreference, setRoomPreference] = useState("");
    const [hobbyAndDream, setHobbyAndDream] = useState("");

    // Payment and Submission states
    const [userid, setUserId] = useState('');
    const [message, setMessage] = useState(false);
    const [formStatus, setFormStatus] = useState('error');
    const [logText, setLogText] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const price = (roomPreference === "AC" ? 3000 : roomPreference === "Non-AC" ? 2500 : 0);

    // Helpers
    const validateEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const validatePhone = (phone) => {
        const digits = (phone || '').replace(/\D/g, '');
        return digits.length === 10;
    };

    // Image compression helper: compress to target max size (KB)
    const compressImage = (file, maxSizeKB = 1024, maxDimension = 1200) => {
        return new Promise((resolve, reject) => {
            if (!file || !file.type.startsWith('image/')) return resolve(file);
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (event) => {
                const img = new Image();
                img.src = event.target.result;
                img.onload = () => {
                    let width = img.width;
                    let height = img.height;
                    // resize to max dimension keeping aspect ratio
                    if (width > maxDimension || height > maxDimension) {
                        if (width > height) {
                            height = Math.round((maxDimension / width) * height);
                            width = maxDimension;
                        } else {
                            width = Math.round((maxDimension / height) * width);
                            height = maxDimension;
                        }
                    }

                    const canvas = document.createElement('canvas');
                    canvas.width = width;
                    canvas.height = height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, width, height);

                    // try decreasing quality until size is OK
                    const mime = 'image/jpeg';
                    let quality = 0.92;

                    const attempt = () => {
                        canvas.toBlob((blob) => {
                            if (!blob) return reject(new Error('Compression failed'));
                            if (blob.size / 1024 <= maxSizeKB || quality <= 0.45) {
                                // create File to preserve filename
                                const compressedFile = new File([blob], file.name.replace(/\s+/g, '_'), { type: mime });
                                resolve(compressedFile);
                            } else {
                                quality -= 0.08;
                                attempt();
                            }
                        }, mime, quality);
                    };

                    attempt();
                };
                img.onerror = () => reject(new Error('Invalid image'));
            };
            reader.onerror = () => reject(new Error('File read error'));
        });
    };

    const validateStep = (step = activeStep) => {
        const newErrors = {};

        if (step === 0) {
            if (!consentChecked) newErrors.consent = "You must read and agree to the rules to continue";
        }

        if (step === 1) {
            if (!studentFullName.trim()) newErrors.studentFullName = "Full name is required";
            if (!studentAge.trim()) newErrors.studentAge = "Age is required";
            else if (Number.isNaN(parseInt(studentAge, 10)) || parseInt(studentAge, 10) <= 0)
                newErrors.studentAge = "Enter a valid age";
            if (!studentGender) newErrors.studentGender = "Gender is required";
            if (!studentDOB.trim()) newErrors.studentDOB = "Date of Birth is required";
            if (!city.trim()) newErrors.city = "City is required";
            if (!fullAddress.trim()) newErrors.fullAddress = "Full address is required";
        }

        if (step === 2) {
            if (!parentMobileNo.trim()) newErrors.parentMobileNo = "Mobile number is required";
            else if (!validatePhone(parentMobileNo))
                newErrors.parentMobileNo = "Enter a valid mobile number (10 digits)";
            if (!parentEmailId.trim()) newErrors.parentEmailId = "Email ID is required";
            else if (!validateEmail(parentEmailId))
                newErrors.parentEmailId = "Enter a valid email address";
            if (!parentPanNo.trim()) newErrors.parentPanNo = "PAN Number is required";
        }

        if (step === 3) {
            if (!passportPhoto) newErrors.passportPhoto = "Passport size photo is required";
            if (!aadharCard) newErrors.aadharCard = "Aadhar card is required";
            if (!roomPreference) newErrors.roomPreference = "Room preference is required";
            if (!hobbyAndDream.trim()) newErrors.hobbyAndDream = "Hobby and dream details are required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateAll = () => {
        const allErrors = {};

        if (!consentChecked) allErrors.consent = "You must read and agree to the rules to continue";

        // Step 1 validation
        if (!studentFullName.trim()) allErrors.studentFullName = "Full name is required";
        if (!studentAge.trim()) allErrors.studentAge = "Age is required";
        else if (Number.isNaN(parseInt(studentAge, 10)) || parseInt(studentAge, 10) <= 0)
            allErrors.studentAge = "Enter a valid age";
        if (!studentGender) allErrors.studentGender = "Gender is required";
        if (!studentDOB.trim()) allErrors.studentDOB = "Date of Birth is required";
        if (!city.trim()) allErrors.city = "City is required";
        if (!fullAddress.trim()) allErrors.fullAddress = "Full address is required";

        // Step 2 validation
        if (!parentMobileNo.trim()) allErrors.parentMobileNo = "Mobile number is required";
        else if (!validatePhone(parentMobileNo))
            allErrors.parentMobileNo = "Enter a valid mobile number (10 digits)";
        if (!parentEmailId.trim()) allErrors.parentEmailId = "Email ID is required";
        else if (!validateEmail(parentEmailId))
            allErrors.parentEmailId = "Enter a valid email address";
        if (!parentPanNo.trim()) allErrors.parentPanNo = "PAN Number is required";

        // Step 3 validation
        if (!passportPhoto) allErrors.passportPhoto = "Passport size photo is required";
        if (!aadharCard) allErrors.aadharCard = "Aadhar card is required";
        if (!roomPreference) allErrors.roomPreference = "Room preference is required";
        if (!hobbyAndDream.trim()) allErrors.hobbyAndDream = "Hobby and dream details are required";

        setErrors(allErrors);
        return Object.keys(allErrors).length === 0;
    };

    const loadScript = (src) => {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
            document.body.appendChild(script);
        });
    };

    const initiateSubmission = async (formData, e) => {
        await loadScript("https://checkout.razorpay.com/v1/checkout.js");
        setMessage(true);
        setFormStatus('info');
        setLogText('Submitting... Please wait !');
        setIsSubmitting(true);
        await axios({
            url: 'https://satprerna.org/satprerna_backend/home/masttshaala2026_register.php',
            method: 'post',
            data: formData,
            responseType: 'json'
        })
            .then((response) => {
                setUserId(response.data.id);
                if (price > 0) {
                    setFormStatus('info');
                    setLogText('Please complete payment...');
                    paymentHandler(response.data.id, e)
                }
                else {
                    setMessage(true);
                    setFormStatus('success');
                    setLogText('Submitted Successfully !');
                    setIsSubmitting(false);
                    sendEmail(parentEmailId);
                    // Reset form
                    resetForm();
                }
            })
            .catch(err => {
                setMessage(true)
                setFormStatus('error')
                setLogText('Something went wrong !')
                setIsSubmitting(false);
            })
    }

    const paymentHandler = (id, e) => {
        e.preventDefault();
        const options = {
            key: 'rzp_live_bH8zSPYWzsshms',
            amount: price * 100,
            name: 'Satprerna Trust',
            "handler": async function (response) {
                const paymentId = response.razorpay_payment_id;
                const formData = new FormData();
                formData.append("razorpay_payment_id", paymentId);
                formData.append("payment_status", "Paid");
                formData.append("id", id);
                setMessage(true);
                setFormStatus('info');
                setLogText('Submitting...');
                await axios({
                    url: 'https://satprerna.org/satprerna_backend/home/masttshaala2026_update_status.php',
                    method: 'post',
                    data: formData,
                    responseType: 'json'
                })
                    .then(() => {
                        setMessage(true);
                        setFormStatus('success');
                        setLogText('Payment Completed Successfully !');
                        setIsSubmitting(false);
                        sendEmail(parentEmailId);
                        resetForm();
                    })
                    .catch(err => {
                        setMessage(true)
                        setFormStatus('error')
                        setLogText('Something went wrong')
                        setIsSubmitting(false);
                    })
            },
            modal: {
                escape: false,
                ondismiss() {
                    setMessage(true);
                    setFormStatus('error')
                    setLogText('Payment Failed. Registration Cancelled !')
                    setIsSubmitting(false);
                }
            },
            prefill: {
                name: studentFullName,
                email: parentEmailId
            },
            notes: {
                address: ''
            },
            theme: {
                color: '#fa6400',
            },
        };
        const rzp1 = new window.Razorpay(options);
        rzp1.open();
    }

    const resetForm = () => {
        setStudentFullName('');
        setStudentAge('');
        setStudentGender('');
        setStudentDOB('');
        setCity('');
        setFullAddress('');
        setParentMobileNo('');
        setParentEmailId('');
        setParentPanNo('');
        setPassportPhoto(null);
        setAadharCard(null);
        setRoomPreference('');
        setHobbyAndDream('');
        setActiveStep(0);
        setConsentChecked(false);
    };

    const previewTable = () => `
        <table border="1" cellpadding="6" cellspacing="0" width="100%" style="border-collapse:collapse;">
            <tbody>
                <tr style="background:#e8f0fe;">
                    <td><strong>Field</strong></td>
                    <td><strong>Details</strong></td>
                </tr>
                <tr>
                    <td>Student Name</td>
                    <td>${studentFullName}</td>
                </tr>
                <tr>
                    <td>Age</td>
                    <td>${studentAge}</td>
                </tr>
                <tr>
                    <td>Gender</td>
                    <td>${studentGender}</td>
                </tr>
                <tr>
                    <td>Date of Birth</td>
                    <td>${studentDOB}</td>
                </tr>
                <tr>
                    <td>City</td>
                    <td>${city}</td>
                </tr>
                <tr>
                    <td>Full Address</td>
                    <td>${fullAddress}</td>
                </tr>
                <tr>
                    <td>Parent Mobile</td>
                    <td>${parentMobileNo}</td>
                </tr>
                <tr>
                    <td>Parent Email</td>
                    <td>${parentEmailId}</td>
                </tr>
                <tr>
                    <td>PAN Number</td>
                    <td>${parentPanNo}</td>
                </tr>
                <tr>
                    <td>Room Preference</td>
                    <td>${roomPreference}</td>
                </tr>
                <tr>
                    <td>Amount Paid</td>
                    <td>₹${price}</td>
                </tr>
                <tr>
                    <td>Hobby and Dream</td>
                    <td>${hobbyAndDream}</td>
                </tr>
            </tbody>
        </table>`;

    const sendEmail = (to_email) => {
        const emailParams = {
            to_email,
            studentName: studentFullName,
            preview_table: previewTable()
        }

        emailjs.send("service_8m18sys", "template_uh4himl", emailParams, "user_sY1m8Ki5Oafoc32NNK9TG");
    };

    const handleNext = () => {
        if (!validateStep()) return;
        setActiveStep((prev) => prev + 1);
    };

    const handleBack = () => setActiveStep((prev) => prev - 1);

    const renderStepContent = (key) => {
        switch (key) {
            case 0:
                return (
                    <div className={classes.stepContent}>
                        <div className={classes.rulesBox}>
                            <RulesContent />
                        </div>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={consentChecked}
                                    onChange={(e) => {
                                        setConsentChecked(e.target.checked);
                                        if (e.target.checked) {
                                            setErrors({ ...errors, consent: '' });
                                        }
                                    }}
                                    color="primary"
                                />
                            }
                            label="I have read carefully and agree to the Rules and Terms & Conditions"
                        />
                        {errors.consent && <p className={classes.errorText}>{errors.consent}</p>}
                    </div>
                );

            case 1:
                return (
                    <div className={classes.stepContent}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Full Name"
                            value={studentFullName}
                            onChange={(e) => setStudentFullName(e.target.value)}
                            required
                            error={!!errors.studentFullName}
                            helperText={errors.studentFullName}
                            className={classes.formField}
                        />
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Age"
                            value={studentAge}
                            onChange={(e) => setStudentAge(e.target.value.replace(/\D/g, ''))}
                            required
                            error={!!errors.studentAge}
                            helperText={errors.studentAge}
                            className={classes.formField}
                        />
                        <FormControl variant="outlined" fullWidth error={!!errors.studentGender} className={classes.formField}>
                            <InputLabel>Gender</InputLabel>
                            <Select
                                value={studentGender}
                                onChange={(e) => setStudentGender(e.target.value)}
                                required
                                MenuProps={{
                                    disableScrollLock: true
                                }}
                            >
                                <MenuItem value="Male">Male</MenuItem>
                                <MenuItem value="Female">Female</MenuItem>
                                <MenuItem value="Other">Other</MenuItem>
                            </Select>
                            {errors.studentGender && <p className={classes.errorText}>{errors.studentGender}</p>}
                        </FormControl>
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Date of Birth"
                            type="date"
                            value={studentDOB}
                            onChange={(e) => setStudentDOB(e.target.value)}
                            required
                            error={!!errors.studentDOB}
                            helperText={errors.studentDOB}
                            className={classes.formField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="City"
                            value={city}
                            onChange={(e) => setCity(e.target.value)}
                            required
                            error={!!errors.city}
                            helperText={errors.city}
                            className={classes.formField}
                        />
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Full Address"
                            multiline
                            rows={3}
                            value={fullAddress}
                            onChange={(e) => setFullAddress(e.target.value)}
                            required
                            error={!!errors.fullAddress}
                            helperText={errors.fullAddress}
                            className={classes.formField}
                        />
                    </div>
                );

            case 2:
                return (
                    <div className={classes.stepContent}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Mobile Number"
                            value={parentMobileNo}
                            onChange={(e) => setParentMobileNo(e.target.value.replace(/\D/g, ''))}
                            required
                            error={!!errors.parentMobileNo}
                            helperText={errors.parentMobileNo}
                            className={classes.formField}
                        />
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Email ID"
                            value={parentEmailId}
                            onChange={(e) => setParentEmailId(e.target.value)}
                            required
                            error={!!errors.parentEmailId}
                            helperText={errors.parentEmailId}
                            className={classes.formField}
                        />
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="PAN Number"
                            value={parentPanNo}
                            onChange={(e) => setParentPanNo(e.target.value)}
                            required
                            error={!!errors.parentPanNo}
                            helperText={errors.parentPanNo}
                            className={classes.formField}
                        />
                    </div>
                );

            case 3:
                return (
                    <div className={classes.stepContent}>
                        <div className={classes.formField}>
                            <input 
                                type="file" 
                                id="passport-photo-file" 
                                accept="image/*" 
                                onChange={async (e) => {
                                    const f = e.target.files[0];
                                    if (!f) return;
                                    try {
                                        const compressed = await compressImage(f, 1024);
                                        setPassportPhoto(compressed);
                                        setErrors({ ...errors, passportPhoto: '' });
                                    } catch (err) {
                                        setErrors({ ...errors, passportPhoto: 'Failed to process image' });
                                    }
                                }}
                                style={{ display: 'none' }} 
                            />
                            <label htmlFor="passport-photo-file">
                                <Button variant="contained" color="primary" component="span" size="large">
                                    Upload Passport Size Photo
                                </Button>
                            </label>
                            {passportPhoto && <img src={URL.createObjectURL(passportPhoto)} alt="passport" className={classes.uploadedImg} />}
                            {errors.passportPhoto && <p className={classes.errorText}>{errors.passportPhoto}</p>}
                        </div>

                        <div className={classes.formField}>
                            <input 
                                type="file" 
                                id="aadhar-card-file" 
                                accept="image/*" 
                                onChange={async (e) => {
                                    const f = e.target.files[0];
                                    if (!f) return;
                                    try {
                                        const compressed = await compressImage(f, 1024);
                                        setAadharCard(compressed);
                                        setErrors({ ...errors, aadharCard: '' });
                                    } catch (err) {
                                        setErrors({ ...errors, aadharCard: 'Failed to process image' });
                                    }
                                }}
                                style={{ display: 'none' }} 
                            />
                            <label htmlFor="aadhar-card-file">
                                <Button variant="contained" color="primary" component="span" size="large">
                                    Upload Aadhar Card
                                </Button>
                            </label>
                            {aadharCard && <img src={URL.createObjectURL(aadharCard)} alt="aadhar" className={classes.uploadedImg} />}
                            {errors.aadharCard && <p className={classes.errorText}>{errors.aadharCard}</p>}
                        </div>

                        <FormControl variant="outlined" fullWidth error={!!errors.roomPreference} className={classes.formField}>
                            <InputLabel>Room Preference</InputLabel>
                            <Select
                                value={roomPreference}
                                onChange={(e) => setRoomPreference(e.target.value)}
                                required
                                MenuProps={{
                                    disableScrollLock: true
                                }}
                            >
                                <MenuItem value="AC">AC (₹3000 for 5 days)</MenuItem>
                                <MenuItem value="Non-AC">Non-AC (₹2500 for 5 days)</MenuItem>
                            </Select>
                            {errors.roomPreference && <p className={classes.errorText}>{errors.roomPreference}</p>}
                        </FormControl>

                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Hobby and Dream"
                            multiline
                            rows={4}
                            value={hobbyAndDream}
                            onChange={(e) => setHobbyAndDream(e.target.value)}
                            required
                            error={!!errors.hobbyAndDream}
                            helperText={errors.hobbyAndDream}
                            className={classes.formField}
                        />
                    </div>
                );

            case 4:
                return (
                    <div className={classes.stepContent}>
                        <table className={classes.previewTable}>
                            <tbody>
                                <tr style={{ background: '#e8f0fe' }}>
                                    <td style={{ padding: '12px', border: '1px solid #e0e0e0', fontWeight: 600 }}>Field</td>
                                    <td style={{ padding: '12px', border: '1px solid #e0e0e0', fontWeight: 600 }}>Details</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '12px', border: '1px solid #e0e0e0' }}>Student Name</td>
                                    <td style={{ padding: '12px', border: '1px solid #e0e0e0' }}>{studentFullName}</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '12px', border: '1px solid #e0e0e0' }}>Age</td>
                                    <td style={{ padding: '12px', border: '1px solid #e0e0e0' }}>{studentAge}</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '12px', border: '1px solid #e0e0e0' }}>Gender</td>
                                    <td style={{ padding: '12px', border: '1px solid #e0e0e0' }}>{studentGender}</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '12px', border: '1px solid #e0e0e0' }}>Date of Birth</td>
                                    <td style={{ padding: '12px', border: '1px solid #e0e0e0' }}>{studentDOB}</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '12px', border: '1px solid #e0e0e0' }}>Parent Mobile</td>
                                    <td style={{ padding: '12px', border: '1px solid #e0e0e0' }}>{parentMobileNo}</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '12px', border: '1px solid #e0e0e0' }}>Parent Email</td>
                                    <td style={{ padding: '12px', border: '1px solid #e0e0e0' }}>{parentEmailId}</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '12px', border: '1px solid #e0e0e0' }}>PAN Number</td>
                                    <td style={{ padding: '12px', border: '1px solid #e0e0e0' }}>{parentPanNo}</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '12px', border: '1px solid #e0e0e0' }}>Room Preference</td>
                                    <td style={{ padding: '12px', border: '1px solid #e0e0e0' }}>{roomPreference}</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '12px', border: '1px solid #e0e0e0' }}>Hobby and Dream</td>
                                    <td style={{ padding: '12px', border: '1px solid #e0e0e0' }}>{hobbyAndDream}</td>
                                </tr>
                            </tbody>
                        </table>
                        {price>0 && <Grid container spacing={1}>
                        <p style={{ color: 'red', marginTop: '30px' }}>
                            <b>Registration will be marked completed only after payment of ₹{price} is done in next step.</b><br /><br />
                            <b>Acknowledgement email will be sent on the provided email address after payment confirmation.</b><br /><br />
                        </p>
                        </Grid>}
                    </div>
                );

            default:
                return null;
        }
    };

    const handleFormSubmit = (e) => {
        if (!validateAll()) return;

        // Create FormData for file upload
        const formData = new FormData();
        formData.append('consent', consentChecked ? 1 : 0);
        formData.append('studentFullName', studentFullName.trim());
        formData.append('studentAge', studentAge.trim());
        formData.append('studentGender', studentGender);
        formData.append('studentDOB', studentDOB);
        formData.append('city', city.trim());
        formData.append('fullAddress', fullAddress.trim());
        formData.append('parentMobileNo', parentMobileNo.trim());
        formData.append('parentEmailId', parentEmailId.trim());
        formData.append('parentPanNo', parentPanNo.trim());
        formData.append('roomPreference', roomPreference);
        formData.append('hobbyAndDream', hobbyAndDream.trim());
        formData.append('price', price);
        formData.append('payment_status', 'pending');
        formData.append('razorpay_payment_id', '');
        
        if (passportPhoto) {
            formData.append('passportPhoto', passportPhoto);
        }
        if (aadharCard) {
            formData.append('aadharCard', aadharCard);
        }

        initiateSubmission(formData, e);
    };

    return (
        <div className={classes.rootouter}>
            <svg className={'wavy-divider ' + classes.divider} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 300" preserveAspectRatio="none" width="100%" height="100">
                <path d="M 1000 299 l 2 -279 c -155 -36 -310 135 -415 164 c -102.64 28.35 -149 -32 -232 -31 c -80 1 -142 53 -229 80 c -65.54 20.34 -101 15 -126 11.61 v 54.39 z"></path>
                <path d="M 1000 286 l 2 -252 c -157 -43 -302 144 -405 178 c -101.11 33.38 -159 -47 -242 -46 c -80 1 -145.09 54.07 -229 87 c -65.21 25.59 -104.07 16.72 -126 10.61 v 22.39 z"></path>
                <path d="M 1000 300 l 1 -230.29 c -217 -12.71 -300.47 129.15 -404 156.29 c -103 27 -174 -30 -257 -29 c -80 1 -130.09 37.07 -214 70 c -61.23 24 -108 15.61 -126 10.61 v 22.39 z"></path>
            </svg>
            <div className={classes.root}>
                
                <img src={require('../../src/images/masttshaala/masttshaala2026_satprerna_trust.png')} alt="Masttshaala 2026" width="100%" />
                <h2 className="mt-5 t1-sgp">Masttshaala 2026 Registration Form</h2>
                <p className='my-4'>
                    <b>Please fill the form carefully.</b> Ensure that all details are correct. Incomplete or incorrect forms may lead to issues.
                </p>

                <Stepper
                    activeStep={activeStep}
                    orientation='vertical'
                    className={`${classes.stepper} ${classes.stepperVertical}`}
                >
                    {steps.map((label, key) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                            <StepContent>
                                <div>{renderStepContent(key)}</div>
                                <div className={classes.actionRow}>
                                    <Button disabled={activeStep === 0} onClick={handleBack}>
                                        Back
                                    </Button>

                                    {activeStep === steps.length - 1 ? (
                                        <Button className={classes.primaryButton} variant="contained" onClick={handleFormSubmit}>
                                            Submit
                                        </Button>
                                    ) : (
                                        <Button
                                            className={classes.primaryButton}
                                            variant="contained"
                                            onClick={handleNext}
                                            disabled={activeStep === 0 && !consentChecked}
                                        >
                                            Next
                                        </Button>
                                    )}
                                </div>
                            </StepContent>
                        </Step>
                    ))}
                </Stepper>
            </div>
            <Snackbar open={message} autoHideDuration={formStatus !== 'success' ? null : 5000} onClose={() => setMessage(false)} anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
                <Alert onClose={() => setMessage(false)} severity={formStatus}>
                    {logText}
                </Alert>
            </Snackbar>
        </div>
    );
}

function RulesContent() {
    return (
      <div>
        <h6><b>MASTTSHALA 2026 - IMPORTANT GUIDELINES</b></h6>
        <ol>
          <li>
            Registration is compulsory. Last date for registration is 28 May 2026 till 8 PM. Late entries will not be accepted.
          </li>
          <li>
            Camp Reporting: 02 June 2026 between 3 PM to 5 PM at Anand Bhavan (Direct reporting).
          </li>
          <li>
            Age Eligibility: 13 to 19 years only.
          </li>
          <li>
            Dress Code: Simple, loose and comfortable clothes. Jeans and half pants are not allowed.
            <br />
            (T-Shirts/Kurtas : Day 1 - White, Day 2 - Orange, Day 3 - Pink, Day 4 - White, Day 5 - Orange)
          </li>
          <li>
            Camp Fees: AC Room - ₹3000 | Non-AC Room - ₹2500
          </li>
          <li>
            Parents are not allowed inside the camp premises.
          </li>
          <li>
            For more details, contact us at 9586886839 | 8850830930
          </li>
        </ol>
      </div>
    );
}
